import { defineComponent as qe, useAttrs as He, inject as Ge, ref as M, computed as u, watch as Qe, nextTick as Z, unref as l, onBeforeUnmount as Xe, provide as fe, openBlock as i, createBlock as p, mergeProps as Ze, withCtx as c, renderSlot as me, withModifiers as w, normalizeStyle as ye, normalizeClass as y, resolveDynamicComponent as R, createCommentVNode as K, createElementVNode as _e, toDisplayString as xe } from "vue";
import { onClickOutside as ea, unrefElement as aa } from "./index562.js";
import { ElInput as la } from "./index545.js";
import { ElIcon as B } from "./index538.js";
import { ElTooltip as oa } from "./index577.js";
import { Clock as na, Calendar as ta } from "./index537.js";
import { valueEquals as ra, dayOrDaysToDate as _ } from "./index578.js";
import { PICKER_POPPER_OPTIONS_INJECTION_KEY as ua, PICKER_BASE_INJECTION_KEY as sa, ROOT_COMMON_PICKER_INJECTION_KEY as ia } from "./index579.js";
import { useCommonPicker as pa } from "./index580.js";
import { timePickerDefaultProps as ca } from "./index581.js";
import da from "./index582.js";
import { useEmptyValues as va } from "./index583.js";
import { UPDATE_MODEL_EVENT as fa, CHANGE_EVENT as he } from "./index584.js";
import { useNamespace as x } from "./index559.js";
import { useFormItem as ma } from "./index585.js";
import { useFormDisabled as ya, useFormSize as ha } from "./index586.js";
import { useFocusController as ba } from "./index587.js";
import { debugWarn as be } from "./index588.js";
import { isArray as ge, NOOP as ke } from "./index575.js";
import { getEventCode as ga } from "./index589.js";
import { EVENT_CODE as E } from "./index590.js";
var La = /* @__PURE__ */ qe({
  name: "Picker",
  __name: "picker",
  props: ca,
  emits: [
    fa,
    he,
    "focus",
    "blur",
    "clear",
    "calendar-change",
    "panel-change",
    "visible-change",
    "keydown"
  ],
  setup(Pe, { expose: Ce, emit: Ie }) {
    const o = Pe, h = Ie, we = He(), v = x("date"), k = x("input"), b = x("range"), { formItem: V } = ma(), Ee = Ge(
      ua,
      {}
    ), P = va(o, null), $ = M(), f = M(), A = M(null);
    let z = !1;
    const d = ya(), ee = pa(o, h), {
      parsedValue: O,
      pickerActualVisible: U,
      userInput: t,
      pickerVisible: r,
      pickerOptions: m,
      valueIsEmpty: N,
      emitInput: C,
      onPick: L,
      onSetPickerOption: ae,
      onCalendarChange: le,
      onPanelChange: oe
    } = ee, { isFocused: J, handleFocus: ne, handleBlur: te } = ba(f, {
      disabled: d,
      beforeFocus() {
        return o.readonly;
      },
      afterFocus() {
        o.automaticDropdown && (r.value = !0);
      },
      beforeBlur(e) {
        var a;
        return !z && ((a = $.value) == null ? void 0 : a.isFocusInsideContent(e));
      },
      afterBlur() {
        Q(), r.value = !1, z = !1, o.validateEvent && V?.validate("blur").catch((e) => be(e));
      }
    }), W = M(!1), Ve = u(() => [
      v.b("editor"),
      v.bm("editor", o.type),
      k.e("wrapper"),
      v.is("disabled", d.value),
      v.is("active", r.value),
      b.b("editor"),
      G ? b.bm("editor", G.value) : "",
      we.class
    ]), Oe = u(() => [
      k.e("icon"),
      b.e("close-icon"),
      j.value ? "" : b.em("close-icon", "hidden")
    ]);
    Qe(r, (e) => {
      e ? Z(() => {
        e && (A.value = o.modelValue);
      }) : (t.value = null, Z(() => {
        Y(o.modelValue);
      }));
    });
    const Y = (e, a) => {
      (a || !ra(e, A.value)) && (h(he, e), a && (A.value = e), o.validateEvent && V?.validate("change").catch((n) => be(n)));
    }, Ne = (e) => {
      h("keydown", e);
    }, Se = u(() => f.value ? Array.from(
      f.value.$el.querySelectorAll("input")
    ) : []), Te = (e, a, n) => {
      const s = Se.value;
      s.length && (!n || n === "min" ? (s[0].setSelectionRange(e, a), s[0].focus()) : n === "max" && (s[1].setSelectionRange(e, a), s[1].focus()));
    }, Fe = () => {
      U.value = !0;
    }, De = () => {
      h("visible-change", !0);
    }, re = () => {
      U.value = !1, r.value = !1, h("visible-change", !1);
    }, Me = () => {
      r.value = !0;
    }, Re = () => {
      r.value = !1;
    }, g = u(() => {
      const e = X(O.value);
      return ge(t.value) ? [
        t.value[0] || e && e[0] || "",
        t.value[1] || e && e[1] || ""
      ] : t.value !== null ? t.value : !Be.value && N.value || !r.value && N.value ? "" : e ? ue.value || se.value || ie.value ? e.join(", ") : e : "";
    }), Ke = u(() => o.type.includes("time")), Be = u(() => o.type.startsWith("time")), ue = u(() => o.type === "dates"), se = u(() => o.type === "months"), ie = u(() => o.type === "years"), S = u(
      () => o.prefixIcon || (Ke.value ? na : ta)
    ), j = u(
      () => o.clearable && !d.value && !o.readonly && !N.value && (W.value || J.value)
    ), q = (e) => {
      o.readonly || d.value || (j.value && (e?.stopPropagation(), m.value.handleClear ? m.value.handleClear() : C(P.valueOnClear.value), Y(P.valueOnClear.value, !0), re()), h("clear"));
    }, T = async (e) => {
      var a;
      o.readonly || d.value || (((a = e.target) == null ? void 0 : a.tagName) !== "INPUT" || J.value || !o.automaticDropdown) && (r.value = !0);
    }, pe = () => {
      o.readonly || d.value || !N.value && o.clearable && (W.value = !0);
    }, ce = () => {
      W.value = !1;
    }, H = (e) => {
      var a;
      o.readonly || d.value || (((a = e.touches[0].target) == null ? void 0 : a.tagName) !== "INPUT" || J.value || !o.automaticDropdown) && (r.value = !0);
    }, $e = u(() => o.type.includes("range")), G = ha(), Ae = u(() => {
      var e, a;
      return (a = (e = l($)) == null ? void 0 : e.popperRef) == null ? void 0 : a.contentRef;
    }), de = ea(
      f,
      (e) => {
        const a = l(Ae), n = aa(f);
        a && (e.target === a || e.composedPath().includes(a)) || e.target === n || n && e.composedPath().includes(n) || (r.value = !1);
      }
    );
    Xe(() => {
      de?.();
    });
    const Q = () => {
      if (t.value) {
        const e = F(g.value);
        e && (D(e) && C(_(e)), t.value = null);
      }
      t.value === "" && (C(P.valueOnClear.value), Y(P.valueOnClear.value, !0), t.value = null);
    }, F = (e) => e ? m.value.parseUserInput(e) : null, X = (e) => e ? ge(e) ? e.map((n) => n.format(o.format)) : e.format(o.format) : null, D = (e) => m.value.isValidValue(e), ve = async (e) => {
      if (o.readonly || d.value) return;
      const a = ga(e);
      if (Ne(e), a === E.esc) {
        r.value === !0 && (r.value = !1, e.preventDefault(), e.stopPropagation());
        return;
      }
      if (a === E.down && (m.value.handleFocusPicker && (e.preventDefault(), e.stopPropagation()), r.value === !1 && (r.value = !0, await Z()), m.value.handleFocusPicker)) {
        m.value.handleFocusPicker();
        return;
      }
      if (a === E.tab) {
        z = !0;
        return;
      }
      if (a === E.enter || a === E.numpadEnter) {
        r.value ? (t.value === null || t.value === "" || D(F(g.value))) && (Q(), r.value = !1) : r.value = !0, e.preventDefault(), e.stopPropagation();
        return;
      }
      if (t.value) {
        e.stopPropagation();
        return;
      }
      m.value.handleKeydownInput && m.value.handleKeydownInput(e);
    }, ze = (e) => {
      t.value = e, r.value || (r.value = !0);
    }, Ue = (e) => {
      const a = e.target;
      t.value ? t.value = [a.value, t.value[1]] : t.value = [a.value, null];
    }, Le = (e) => {
      const a = e.target;
      t.value ? t.value = [t.value[0], a.value] : t.value = [null, a.value];
    }, Je = () => {
      var e;
      const a = t.value, n = F(a && a[0]), s = l(O);
      if (n && n.isValid()) {
        t.value = [
          X(n),
          ((e = g.value) == null ? void 0 : e[1]) || null
        ];
        const I = [n, s && (s[1] || null)];
        D(I) && (C(_(I)), t.value = null);
      }
    }, We = () => {
      var e;
      const a = l(t), n = F(a && a[1]), s = l(O);
      if (n && n.isValid()) {
        t.value = [
          ((e = l(g)) == null ? void 0 : e[0]) || null,
          X(n)
        ];
        const I = [s && s[0], n];
        D(I) && (C(_(I)), t.value = null);
      }
    }, Ye = () => {
      var e;
      (e = f.value) == null || e.focus();
    }, je = () => {
      var e;
      (e = f.value) == null || e.blur();
    };
    return fe(sa, {
      props: o,
      emptyValues: P
    }), fe(ia, ee), Ce({
      /**
       * @description focus input box.
       */
      focus: Ye,
      /**
       * @description blur input box.
       */
      blur: je,
      /**
       * @description opens picker
       */
      handleOpen: Me,
      /**
       * @description closes picker
       */
      handleClose: Re,
      /**
       * @description pick item manually
       */
      onPick: L
    }), (e, a) => (i(), p(l(oa), Ze({
      ref_key: "refPopper",
      ref: $,
      visible: l(r),
      effect: "light",
      pure: "",
      trigger: "click"
    }, e.$attrs, {
      role: "dialog",
      teleported: "",
      transition: `${l(v).namespace.value}-zoom-in-top`,
      "popper-class": [`${l(v).namespace.value}-picker__popper`, e.popperClass],
      "popper-style": e.popperStyle,
      "popper-options": l(Ee),
      "fallback-placements": e.fallbackPlacements,
      "gpu-acceleration": !1,
      placement: e.placement,
      "stop-popper-mouse-event": !1,
      "hide-after": 0,
      persistent: "",
      onBeforeShow: Fe,
      onShow: De,
      onHide: re
    }), {
      default: c(() => [
        $e.value ? (i(), p(da, {
          key: 1,
          id: (
            // https://github.com/vuejs/language-tools/issues/2104#issuecomment-3092541527
            e.id
          ),
          ref_key: "inputRef",
          ref: f,
          "model-value": g.value,
          name: (
            // https://github.com/vuejs/language-tools/issues/2104#issuecomment-3092541527
            e.name
          ),
          disabled: l(d),
          readonly: !e.editable || e.readonly,
          "start-placeholder": e.startPlaceholder,
          "end-placeholder": e.endPlaceholder,
          class: y(Ve.value),
          style: ye(e.$attrs.style),
          "aria-label": e.ariaLabel,
          tabindex: e.tabindex,
          autocomplete: "off",
          role: "combobox",
          onClick: T,
          onFocus: l(ne),
          onBlur: l(te),
          onStartInput: Ue,
          onStartChange: Je,
          onEndInput: Le,
          onEndChange: We,
          onMousedown: T,
          onMouseenter: pe,
          onMouseleave: ce,
          onTouchstartPassive: H,
          onKeydown: ve
        }, {
          prefix: c(() => [
            S.value ? (i(), p(l(B), {
              key: 0,
              class: y([l(k).e("icon"), l(b).e("icon")])
            }, {
              default: c(() => [
                (i(), p(R(S.value)))
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class"])) : K("v-if", !0)
          ]),
          "range-separator": c(() => [
            me(e.$slots, "range-separator", {}, () => [
              _e(
                "span",
                {
                  class: y(l(b).b("separator"))
                },
                xe(e.rangeSeparator),
                3
                /* TEXT, CLASS */
              )
            ])
          ]),
          suffix: c(() => [
            e.clearIcon ? (i(), p(l(B), {
              key: 0,
              class: y(Oe.value),
              onMousedown: w(l(ke), ["prevent"]),
              onClick: q
            }, {
              default: c(() => [
                (i(), p(R(e.clearIcon)))
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class", "onMousedown"])) : K("v-if", !0)
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["id", "model-value", "name", "disabled", "readonly", "start-placeholder", "end-placeholder", "class", "style", "aria-label", "tabindex", "onFocus", "onBlur"])) : (i(), p(l(la), {
          key: 0,
          id: (
            // https://github.com/vuejs/language-tools/issues/2104#issuecomment-3092541527
            e.id
          ),
          ref_key: "inputRef",
          ref: f,
          "container-role": "combobox",
          "model-value": (
            // https://github.com/vuejs/language-tools/issues/2104#issuecomment-3092541527
            g.value
          ),
          name: (
            // https://github.com/vuejs/language-tools/issues/2104#issuecomment-3092541527
            e.name
          ),
          size: l(G),
          disabled: l(d),
          placeholder: e.placeholder,
          class: y([
            l(v).b("editor"),
            l(v).bm("editor", e.type),
            l(v).is("focus", l(r)),
            e.$attrs.class
          ]),
          style: ye(e.$attrs.style),
          readonly: !e.editable || e.readonly || ue.value || se.value || ie.value || e.type === "week",
          "aria-label": e.ariaLabel,
          tabindex: e.tabindex,
          "validate-event": !1,
          onInput: ze,
          onFocus: l(ne),
          onBlur: l(te),
          onKeydown: ve,
          onChange: Q,
          onMousedown: T,
          onMouseenter: pe,
          onMouseleave: ce,
          onTouchstartPassive: H,
          onClick: a[0] || (a[0] = w(() => {
          }, ["stop"]))
        }, {
          prefix: c(() => [
            S.value ? (i(), p(l(B), {
              key: 0,
              class: y(l(k).e("icon")),
              onMousedown: w(T, ["prevent"]),
              onTouchstartPassive: H
            }, {
              default: c(() => [
                (i(), p(R(S.value)))
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class"])) : K("v-if", !0)
          ]),
          suffix: c(() => [
            j.value && e.clearIcon ? (i(), p(l(B), {
              key: 0,
              class: y(`${l(k).e("icon")} clear-icon`),
              onMousedown: w(l(ke), ["prevent"]),
              onClick: q
            }, {
              default: c(() => [
                (i(), p(R(e.clearIcon)))
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class", "onMousedown"])) : K("v-if", !0)
          ]),
          _: 1
          /* STABLE */
        }, 8, ["id", "model-value", "name", "size", "disabled", "placeholder", "class", "style", "readonly", "aria-label", "tabindex", "onFocus", "onBlur"]))
      ]),
      content: c(() => [
        me(e.$slots, "default", {
          visible: l(r),
          actualVisible: l(U),
          parsedValue: l(O),
          format: e.format,
          dateFormat: e.dateFormat,
          timeFormat: e.timeFormat,
          unlinkPanels: e.unlinkPanels,
          type: e.type,
          defaultValue: e.defaultValue,
          showNow: e.showNow,
          showConfirm: e.showConfirm,
          showFooter: e.showFooter,
          showWeekNumber: e.showWeekNumber,
          onPick: a[1] || (a[1] = //@ts-ignore
          (...n) => l(L) && l(L)(...n)),
          onSelectRange: Te,
          onSetPickerOption: a[2] || (a[2] = //@ts-ignore
          (...n) => l(ae) && l(ae)(...n)),
          onCalendarChange: a[3] || (a[3] = //@ts-ignore
          (...n) => l(le) && l(le)(...n)),
          onClear: q,
          onPanelChange: a[4] || (a[4] = //@ts-ignore
          (...n) => l(oe) && l(oe)(...n)),
          onMousedown: a[5] || (a[5] = w(() => {
          }, ["stop"]))
        })
      ]),
      _: 3
      /* FORWARDED */
    }, 16, ["visible", "transition", "popper-class", "popper-style", "popper-options", "fallback-placements", "placement"]));
  }
});
export {
  La as default
};
